var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalHeaderRuLangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 0C8.44961 0 2.89961 4.2 0.849609 10H29.1496C27.0496 4.2 21.4996 0 14.9496 0Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 30C21.4996 30 27.0496 25.8 29.0996 20H0.849609C2.89961 25.85 8.44961 30 14.9496 30Z",
    fill: "#ED4C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.85 10C0.3 11.55 0 13.25 0 15C0 16.75 0.3 18.45 0.85 20H29.15C29.7 18.45 30 16.75 30 15C30 13.25 29.7 11.55 29.15 10H0.85Z",
    fill: "#428BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalHeaderRuLangIcon);
export default __webpack_public_path__ + "static/media/terminalHeaderRuLangIcon.42bc5432843afa2438dea31d4f7748a1.svg";
export { ForwardRef as ReactComponent };